module.exports = __webpack_public_path__ + "static/media/bancolombia-networking-003.bfd72cc5.jpg";